module.exports = __webpack_public_path__ + "static/media/logo.bf5b093e.png";